import { Link, useRouterState } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

const TABS: ReadonlyArray<{ to: string; icon: string; labelKey: string }> = [
  { to: "/", icon: "🏠", labelKey: "tab.home" },
  { to: "/catalog", icon: "🛍", labelKey: "tab.catalog" },
  { to: "/warehouse", icon: "🏬", labelKey: "tab.warehouse" },
  { to: "/orders", icon: "📦", labelKey: "tab.orders" },
  { to: "/profile", icon: "👤", labelKey: "tab.profile" },
];

/**
 * Bottom 5-tab nav · 1:1 design `.tg-bottom-nav` (fixed at viewport bottom,
 * Telegram-safe-area). `is-active` toggles green tint for the matching tab
 * — matched via prefix so `/orders/123` still lights up the Orders tab.
 */
export function TgBottomNav() {
  const { t } = useTranslation("account");
  const path = useRouterState({ select: (s) => s.location.pathname });

  const isActive = (to: string) => {
    if (to === "/") return path === "/" || path === "";
    return path === to || path.startsWith(`${to}/`);
  };

  return (
    <nav className="tg-bottom-nav">
      {TABS.map((tab) => (
        <Link key={tab.to} to={tab.to as never} className={isActive(tab.to) ? "is-active" : ""}>
          <span className="ic">{tab.icon}</span>
          <span className="lbl">{t(tab.labelKey as never)}</span>
        </Link>
      ))}
    </nav>
  );
}
